export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const SET_USER = 'SET_USER';
export const LOADING_USER = 'LOADING_USER';
// UI Reducer Types
export const SET_ERRORS = 'SET_ERRORS';
export const LOADING_UI = 'LOADING_UI';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
//data reducer types
export const SET_STOCKS = 'SET_STOCKS';
export const LOADING_STOCKS = 'LOADING_STOCKS';
export const LOADING_CURR_STOCK = 'LOADING_CURR_STOCK';
export const SET_CURR_STOCK = 'SET_CURR_STOCK';
//score types
export const SET_SCORES = 'SET_SCORES';
export const LOADING_SCORES = 'LOADING_SCORES';

//other user types
export const SET_OTHER_USER_STOCKS = 'SET_OTHER_USER_STOCKS';
export const LOADING_OTHER_USER_STOCKS = 'LOADING_OTHER_USER_STOCKS';
